import { useTranslation } from '@axo/shared/i18n';
import { FormProvider, useForm } from 'react-hook-form';
import { Form } from '../../../../../components/Form';
import { Navigation } from '../../../../../components/Navigation';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import useInitiatedTracking from '../../../../../hooks/tracking/useInitiatedTracking';
import { DenmarkFormData, Step3Data } from '../../FormData.dk.types';
import { CarFormGroup } from './CarFormGroup';
import { ChildrenFormGroup } from './ChildrenFormGroup';
import { CitizenFormGroup } from './CitizenFormGroup';
import { PartnerFormGroup } from './PartnerFormGroup';

const defaultValues: Step3Data = {
  'Frontend/HasLease': null,
  'LoanApplication/ResidencePermit': null,
  'LoanApplication/ResidencePermitType': null,
};

const touchedFieldsOverride = ['Frontend/IsDanish'];

export function Step3() {
  const { t } = useTranslation();
  const { onChange, onSubmit, axoFormData } =
    useAxoFormContext<DenmarkFormData>();

  const form = useForm({
    defaultValues: {
      ...defaultValues,
      'Frontend/IsDanish':
        axoFormData['Frontend/IsDanish'] !== undefined
          ? axoFormData['Frontend/IsDanish']
          : true,
      'LoanApplication/Citizenship': axoFormData['Frontend/IsDanish']
        ? 'DK'
        : axoFormData['LoanApplication/Citizenship'],
    },
    shouldUnregister: true,
    mode: 'onBlur',
  });

  const {
    formState: { touchedFields, isSubmitting },
  } = form;

  useInitiatedTracking({
    shouldTriggerOnInitiated: Object.keys(touchedFields).length > 0,
  });

  return (
    <FormProvider {...form}>
      <Form
        onSubmit={onSubmit}
        onChange={onChange}
        /* We need to override the touched attribute for this for it to trigger a change immediately when it is interacted with.
         Otherwise, the user would need to interact with another field before the change is triggered.*/
        touchedFieldsOverride={touchedFieldsOverride}
      >
        <PartnerFormGroup />

        <ChildrenFormGroup />

        <CarFormGroup />

        <CitizenFormGroup />

        <Navigation.Continue loading={isSubmitting}>
          {t('next')}
        </Navigation.Continue>
      </Form>
    </FormProvider>
  );
}
